import cx from 'classnames';

import { MIXPANEL_SESSION_REPLAY_CLASS } from 'helpers/mixpanel-init';
import Box from 'UIKit/Box';

import AccountValueCollapsableCard from './AccountValueCollapsableCard';
import AvailableForTrading from './AvailableForTrading';
import { ConversionRate } from './ConversionRate/ConversionRate';
import DeltaCash from './DeltaCash';
import styles from './indianWallet.module.scss';
import { ReferralCommission } from './ReferralCommission';
import SmartAssetEquity from './smartAssetEquity';

const MenuBottom = ({ showAmount }: { showAmount: boolean }) => {
  return (
    <Box
      className={cx(
        styles['wallet-menu'],
        styles.walletMenuBottomContainer,
        MIXPANEL_SESSION_REPLAY_CLASS
      )}
    >
      {/* Account Value */}
      <AccountValueCollapsableCard showAmount={showAmount} />

      {/* Available for trading */}
      <AvailableForTrading
        showAmount={showAmount}
        className={styles.availableForTradingContainer}
      />

      {/* Smart Asset */}
      <SmartAssetEquity
        showAmount={showAmount}
        className={styles.smartAssetEquityContainer}
      />

      {/* Referral Commission */}
      <ReferralCommission
        showAmount={showAmount}
        className={styles.referralCommissionContainer}
      />

      {/* Delta Cash */}
      <DeltaCash showAmount={showAmount} className={styles.deltaCashContainer} />

      {/* Conversion Rate */}
      <ConversionRate className={styles.conversionRateContainer} />
    </Box>
  );
};

export default MenuBottom;
